import React from "react";
import Button from "../../../components/dashboard/Button";
import { LucideGrid, LucideList, LucidePlus, LucideSearch } from "lucide-react";
import { useNavigate } from "react-router-dom";
import Input from "../../../components/dashboard/Input";

const ListPSPPage: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div className="p-6 space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">PSP Management</h1>
          <p className="text-gray-600">Manage your Patient Support Programs</p>
        </div>
        <Button
          onClick={() => {
            navigate("/launchpad/psp/create");
          }}
        >
          <div className="flex items-center gap-2">
            <LucidePlus className="w-4 h-4" />
            <span>Create PSP</span>
          </div>
        </Button>
      </div>

      <div className="flex items-center justify-between">
        <Input
          name="search"
          type="text"
          placeholder="Search PSPs..."
          startAdornment={<LucideSearch className="w-4 h-4" />}
        />

        <div className="flex items-center gap-2">
          <Button variant="outlined">
            <LucideGrid className="w-4 h-4" />
          </Button>
          <Button>
            <LucideList className="w-4 h-4" />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ListPSPPage;
